import script from "./UploadDocumentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadDocumentModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadDocumentModal.vue?vue&type=style&index=0&id=a9ea0150&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9ea0150"]])

export default __exports__